export default __webpack_public_path__ + "static/media/img08.fefd6f69.jpg";